export enum ErrorType {
  REQUIRED = 'REQUIRED',
  WRONG_LIST_SIZE = 'WRONG_LIST_SIZE',
  RANGE = 'RANGE',
  INVALID_VALUE = 'INVALID_VALUE',
  OTHER = 'OTHER',
  UNEXPECTED_VALUE = 'UNEXPECTED_VALUE'
}


export class ValidationError {
  key: string;
  errorType: ErrorType;

  constructor(key: string, errorType: ErrorType) {
    this.key = key;
    this.errorType = errorType;
  }

  static deserialize(json: any): ValidationError {
    const errorType = json['errorType'] as ErrorType;
    switch (errorType) {
      case ErrorType.REQUIRED:
        return new RequiredError(json.key);
      case ErrorType.WRONG_LIST_SIZE:
        return new WrongListSizeError(json.key, json.actual, json.expected);
      case ErrorType.INVALID_VALUE:
        return new InvalidValueError(json.key, json.invalidValue, json.validValues, json.codebookMapping);
      case ErrorType.RANGE:
        return new RangeError(json.key, json.min, json.max);
      case ErrorType.UNEXPECTED_VALUE:
        return new UnexpectedValueError(json.key, json.unexpectedValue);
      case ErrorType.OTHER:
      default:
        return new ValidationError(json.key, errorType);
    }
  }

}

export class InvalidValueError extends ValidationError {
  invalidValue: any;
  validValues: any[];
  codebookMapping: boolean;

  constructor(key: string, invalidValue: any, validValues: any[], codebookMapping: boolean) {
    super(key, ErrorType.INVALID_VALUE);
    this.invalidValue = invalidValue;
    this.validValues = validValues;
    this.codebookMapping = codebookMapping;
  }

}

export class UnexpectedValueError extends ValidationError {
  unexpectedValue: any;

  constructor(key: string, unexpectedValue: any) {
    super(key, ErrorType.UNEXPECTED_VALUE);
    this.unexpectedValue = unexpectedValue;
  }

}


export class RequiredError extends ValidationError {
  constructor(key: string) {
    super(key, ErrorType.REQUIRED);
  }
}

export class WrongListSizeError extends ValidationError {
  actual: number;
  expected: number;

  constructor(key: string, actual: number, expected: number) {
    super(
      key,
      ErrorType.WRONG_LIST_SIZE,
    );
    this.actual = actual;
    this.expected = expected;
  }
}

export class RangeError extends ValidationError {
  min: any;
  max: any;

  constructor(key: string, min: any, max: any) {
    super(
      key,
      ErrorType.RANGE,
    );
    this.min = min;
    this.max = max;
  }
}

export class ValidatorResult {
  errors?: ValidationError[];
  subErrors?: Map<string, ValidatorResult>;

  constructor() {
  }


  static deserialize(json: any): ValidatorResult {
    const instance = new ValidatorResult();
    instance.errors = json.errors?.map((error: any) => ValidationError.deserialize(error)) || [];
    instance.subErrors = json.subErrors
      ? Object.keys(json.subErrors).reduce((acc: Map<string, ValidatorResult>, key: string) => {
        acc.set(key, ValidatorResult.deserialize(json.subErrors[key]));
        return acc;
      }, new Map<string, ValidatorResult>())
      : new Map<string, ValidatorResult>();

    return instance;
  }

  public hasErrors(): boolean {
    return !!(this.errors?.length || this.subErrors?.size);
  }

}




